import React, { FunctionComponent } from 'react'
import { ID } from '../../../../types/UtilityTypes'
import { useSelector } from 'react-redux'
import { projectObjectsSelector } from '../../../../utils/selectors'
import ObjectLine from './ObjectLine/ObjectLine'

interface Props {
    projectId: ID,
}

const ObjectList: FunctionComponent<Props> = props => {
    const objects = useSelector(projectObjectsSelector(props.projectId))

    return <>
        {
            objects.map(objectId => <ObjectLine key={objectId} objectId={objectId}/>)
        }
    </>
}

export default ObjectList